// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// function ProtectedRoute({ children }) {
//   const { currentUser } = useAuth();
//   if (!currentUser) {
//     return <Navigate to="/homepage" />;
//   }
//   return children;
// }

// export default ProtectedRoute;

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();

  // AuthProvider ne rend ses enfants qu'une fois l'état d'auth chargé,
  // donc ici on peut directement décider si l'utilisateur est autorisé.
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default ProtectedRoute;
